module.exports = __webpack_public_path__ + "img/logo.a0a5aa38.png";